function getPromoCreative(url) {
    const anchor = document.createElement('a');
    anchor.href = url;
    return `${anchor.pathname}${anchor.search}`;
}

export { getPromoCreative };
